/** Test / orchestration entity names — hide from discovery chrome when better options exist. */
export function isTestEntityName(name: string | null | undefined): boolean {
  const n = (name || '').trim();
  if (!n) return true;
  // Do NOT treat bare "VIZI…" as test — real user VISIs often use that product prefix.
  if (/^(E2E\b|Orch\b|Fix\b|LiveOk|WebFix|ORCH|Dbgx?|Ph\s|Agent)/i.test(n)) return true;
  if (/^(ph|dbg)\d+/i.test(n)) return true;
  if (/^[A-Za-z]{1,4}\s+[A-Za-z]{1,4}\d{4,}$/i.test(n)) return true;
  if (/E2E\s/i.test(n)) return true;
  return false;
}

/** Prefer non-test names; pad with test if needed to fill `limit`. */
export function preferNonTestEntities<T extends { name?: string | null }>(
  items: T[],
  limit: number
): T[] {
  const real = items.filter((i) => !isTestEntityName(i.name));
  if (real.length >= limit) return real.slice(0, limit);
  const rest = items.filter((i) => isTestEntityName(i.name));
  return [...real, ...rest].slice(0, limit);
}
